import React from "react";
import { Row, Col } from "react-bootstrap";
import editprofile from "assets/images/edit-profile.svg";

const PrimaryMachineInfo = ({ user, handleShow }) => {
    return (
        <div className="profile-cards-1">
            <div className="profie-heding">
                <div className="d-flex justify-content-between align-items-center">
                    <h4>Machine Details</h4>
                    <div onClick={() => handleShow("machine")}>
                        <img src={editprofile} className="cursor-pointer" alt="Edit" />
                    </div>
                </div>
            </div>
            <Row className="p-20">
                <Col lg={6}>
                    <p className="light-text-profile">UAS Manufacturer</p>
                    <p className="dark-profile-text mb-0">{user?.uasManufacturer}</p>
                </Col>
                <Col lg={6}>
                    <p className="light-text-profile">UAS Model</p>
                    <p className="dark-profile-text mb-0">{user?.uasModel}</p>
                </Col>
            </Row>
        </div>
    );
};

export default PrimaryMachineInfo;
